import { render } from "./MenuNr4.vue?vue&type=template&id=b02868ae&scoped=true"
import script from "./MenuNr4.vue?vue&type=script&lang=js"
export * from "./MenuNr4.vue?vue&type=script&lang=js"

import "./MenuNr4.vue?vue&type=style&index=0&id=b02868ae&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b02868ae"]])

export default __exports__